import { faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery } from 'react-responsive';
import {
  Col, Heading, Row,
} from '@elevationscu/ui-component-lib';
import { sanitizeEmail, sanitizePhone } from '../../utils/Operations';
import './TitleBanner.scss';

export function BusinessCard({
  loDetails,
}) {
  const formatPhone = (number) => {
    if (number) {
      const areaCode = number.substring(0, 3);
      const prefix = number.substring(3, 6);
      const lineNumber = number.substring(6);

      return `${areaCode}.${prefix}.${lineNumber}`;
    }
    return '';
  };

  // Safe values
  const rawPhone = loDetails?.phone || '8004602889';
  const rawEmail = loDetails?.email || 'refinance@elevationscu.com';

  const sanitizedPhone = sanitizePhone(rawPhone);
  const sanitizedEmail = sanitizeEmail(rawEmail);

  const safePhoneHref = sanitizedPhone ? `tel:${sanitizedPhone}` : '';
  const safeEmailHref = sanitizedEmail ? `mailto:${sanitizedEmail}` : '';

  const displayedPhone = sanitizedPhone ? formatPhone(sanitizedPhone) : '';
  const displayedEmail = sanitizedEmail;

  const isMobile = useMediaQuery({ query: '(max-width: 576px)' });

  return (
    isMobile ? (
      <div>
        <div className="mobileLOBanner">
          <div className="mobileCircleWrapper">
            <div id="greenElipse" className="greenElipse" />
            <div id="darkBlueElipse" className="darkBlueElipse" />
            <div id="blueElipse" className="blueElipse" />
          </div>
          <Row>
            <Col xs={3}>
              <div id="loan_officer_picture_mobile" data-test-id="loan_officer_picture_mobile" className="mobileLOpicture" style={{ backgroundImage: `url(${loDetails?.lo_picture})` }} />
            </Col>
            <Col xs={9}>
              <Row>
                <Col>
                  <Heading id="loan_officer_name_mobile" data-test-id="loan_officer_name_mobile" element="h2" size={4} className="mobileLOHeadingTitle">
                    {' '}
                    Prepared by
                    {' '}
                    {loDetails?.first_name}
                    {' '}
                    {loDetails?.last_name}
                  </Heading>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span className="mobileNMLS" id="loan_officer_nmmls_mobile" data-test-id="loan_officer_nmls_mobile">
                    NMLS ID #
                    {loDetails?.nmls}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={2} />
            <Col>
              <div id="loan_officer_phone_box">
                <a id="loan_officer_phone" className="loContactInformation" href={safePhoneHref} data-test-id="loan_officer_phone_mobile">
                  {displayedPhone}
                </a>
              </div>
              <div id="loan_officer_email_box">
                <a id="loan_officer_email" className="loContactInformation" href={safeEmailHref} data-test-id="loan_officer_email_mobile">
                  {displayedEmail}
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    ) : (
      <div>
        <div className="businessCard">
          <div className="businessCardTop">
            <div id="greenElipse" className="greenElipse" />
            <div id="darkBlueElipse" className="darkBlueElipse" />
            <div id="blueElipse" className="blueElipse" />
            {loDetails
              && (
                <div
                  id="loan_officer_picture"
                  className="loPicture"
                  data-test-id="loan_officer_picture"
                  style={{ backgroundImage: `url(${loDetails?.lo_picture})` }}
                />
              )}
            <span className="businessCardTopText" id="business_card_top_text" data-test-id="business_card_top_text">
              If you have any questions, we are here to help. Feel free to get in touch with us at any point.
            </span>
          </div>
          <div className="businessCardBottom">
            <div className={`businessCardBottomText ${!loDetails && 'centerTextCard'} `}>
              <div id="loan_officer_name" className="loName" data-test-id="loan_officer_name">
                {loDetails && `${loDetails?.first_name} ${loDetails?.last_name}`}
              </div>
              <div id="loan_officer_nmls" className="loNMLS" data-test-id="loan_officer_nmls">
                {loDetails && `NMLS ID #${loDetails?.nmls}`}
              </div>
              <div id="loan_officer_phone_box">
                <FontAwesomeIcon icon={faPhone} className="contactIcon" />
                <a id="loan_officer_phone" className="loContactInformation" href={safePhoneHref} data-test-id="loan_officer_phone">
                  {displayedPhone}
                </a>
              </div>
              <div id="loan_officer_email_box">
                <FontAwesomeIcon icon={faEnvelope} className="contactIcon" />
                <a id="loan_officer_email" className="loContactInformation" href={safeEmailHref} data-test-id="loan_officer_email">
                  {displayedEmail}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
